export enum UserStatus {
  NewAccount = 1,
  Active = 2,
  DeActive = 3,
  Blocked = 4,
  Deleted = 5,
  None = 0,
}
